import { isRouteErrorResponse, useRouteError } from 'react-router';

import { Alert, Button } from '@/components/ui';

/**
 * Route-level error boundary. Catches anything thrown while rendering or
 * loading a route so a single broken page never blanks the whole app.
 */
export function ErrorPage() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'An unexpected error occurred.';

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas p-6">
      <div className="w-full max-w-md">
        <Alert tone="danger" title="Something went wrong">
          {message}
        </Alert>
        <Button
          variant="secondary"
          size="md"
          className="mt-4"
          onClick={() => {
            window.location.assign('/');
          }}
        >
          Reload the app
        </Button>
      </div>
    </div>
  );
}
